<template>
  <div class="d-flex">
    <div class="icon-wrapper">
      <a
        @mouseover="instagramHover = '-hover.svg'"
        @mouseleave="instagramHover = '.svg'"
        @focus="instagramHover = '-hover.svg'"
        @blur="instagramHover = '.svg'"
        href="https://www.instagram.com/oredev/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <img
          :src="
            $_appendToUrl(
              'https://res.cloudinary.com/oredev/image/upload/v1743594623/2025/Social_media/insta',
              instagramHover
            )
          "
          alt=""
          aria-hidden="true"
      /></a>
    </div>
    <div class="icon-wrapper ml-3">
      <a
        @mouseover="facebookHover = '-hover.svg'"
        @mouseleave="facebookHover = '.svg'"
        @focus="facebookHover = '-hover.svg'"
        @blur="facebookHover = '.svg'"
        href="https://www.facebook.com/oredev"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
      >
        <img
          :src="
            $_appendToUrl(
              'https://res.cloudinary.com/oredev/image/upload/v1743594623/2025/Social_media/facebook',
              facebookHover
            )
          "
          alt=""
          aria-hidden="true"
        />
      </a>
    </div>
    <div class="icon-wrapper ml-3">
      <a
        @mouseover="linkedinHover = '-hover.svg'"
        @mouseleave="linkedinHover = '.svg'"
        @focus="linkedinHover = '-hover.svg'"
        @blur="linkedinHover = '.svg'"
        href="https://www.linkedin.com/company/oredev/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn"
      >
        <img
          :src="
            $_appendToUrl(
              'https://res.cloudinary.com/oredev/image/upload/v1743594623/2025/Social_media/linkedin',
              linkedinHover
            )
          "
          alt=""
          aria-hidden="true"
        />
      </a>
    </div>
    <div class="icon-wrapper ml-3">
      <a
        @mouseover="youtubeHover = '-hover.svg'"
        @mouseleave="youtubeHover = '.svg'"
        @focus="youtubeHover = '-hover.svg'"
        @blur="youtubeHover = '.svg'"
        href="https://www.youtube.com/c/%C3%98redevConference"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="YouTube"
      >
        <img
          :src="
            $_appendToUrl(
              'https://res.cloudinary.com/oredev/image/upload/v1743594623/2025/Social_media/youtube',
              youtubeHover
            )
          "
          alt=""
          aria-hidden="true"
        />
      </a>
    </div>
    <div class="icon-wrapper ml-3">
      <a
        @mouseover="bluseskyHover = '-hover.svg'"
        @mouseleave="bluseskyHover = '.svg'"
        @focus="bluseskyHover = '-hover.svg'"
        @blur="bluseskyHover = '.svg'"
        href="https://bsky.app/profile/oredev.org"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Bluesky"
      >
        <img
          :src="
            $_appendToUrl(
              'https://res.cloudinary.com/oredev/image/upload/v1743594623/2025/Social_media/bluesky',
              bluseskyHover
            )
          "
          alt=""
          aria-hidden="true"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { helperMethods } from "@/mixins/helpers";

export default {
  name: "SocialMedia",
  mixins: [helperMethods],
  data() {
    return {
      instagramHover: "-hover.svg",
      facebookHover: "-hover.svg",
      linkedinHover: "-hover.svg",
      youtubeHover: "-hover.svg",
      bluseskyHover: "-hover.svg",
    };
  },
  mounted() {
    // Force browser to preload hover versions by binding them once to the template
    // Then reset to the normal state
    this.instagramHover = ".svg";
    this.facebookHover = ".svg";
    this.linkedinHover = ".svg";
    this.youtubeHover = ".svg";
    this.bluseskyHover = ".svg";
  },
};
</script>

<style lang="scss" scoped>
.icon-wrapper {
  width: 24px; /* match icon size */
  height: 24px;
  position: relative;
  overflow: visible;
  display: inline-block;
}

.icon-wrapper img {
  transition: transform 0.3s ease;
  position: absolute;
  top: 0;
  left: 0;
}
.icon-wrapper a:hover img,
.icon-wrapper a:focus img {
  transform: scale(1.2);
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer/SocialMedia.vue